import { createFileRoute } from '@tanstack/react-router';

import { UsagePage } from '@/features/setting/page/usage-page';

export const Route = createFileRoute('/workspace/$workspaceId/settings/usage')({
  component: UsagePage,
});
